import { styled } from "@mui/material/styles";

const StylesOrderManagemnt = styled("div")(({ theme }) => `
  min-height: 87vh;
    @media screen and (max-width: 600px) {
    margin: 0px 20px;
  }

  .tabs-container {
    max-width: 100%;
    background-color: transparent;
    margin-top: -18px;
    border-bottom: 1px solid ${theme.palette.customColor.secondaryThird};
  }

  .tab-option {
    font-family: Lexend;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0px;
    vertical-align: middle;
    color: ${theme.palette.customColor.secondarySecond};
    text-transform: none;
    padding:13px 16px;
    padding-bottom: 0px;
    text-transform: capitalize;

    @media (max-width: 600px) {
    font-size: 12px;
    line-height: 22px;
    }
  }

 .tab-option.Mui-selected {
    color: ${theme.palette.secondary.main};
  }


 .top-margin{
 margin-top:  20vh;
 }



.search-box .MuiOutlinedInput-root {
margin-top: 16px;
margin-bottom: 24px;
  width: 343px;
  height: 48px;
background-color: ${theme.palette.customColor.white};
  outline: none !important;
    border-radius: 0;
font-family: Lexend;
font-weight: 400;
font-size: 14px;
line-height: 100%;
@media (max-width: 600px) {
    width: calc(100vw - 40px);

}

}


  

  .search-box .MuiOutlinedInput-notchedOutline {
border: 0.8px solid ${theme.palette.customColor.secondaryThird} !important;
  }

.searchIcon{
    width: 20px;
    height: 20px;
}
.action-btn {
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 5px 10px;
  border-radius: 0px;
}
.action-text {
  font-family: Lexend;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  text-transform: none;
  color: ${theme.palette.customColor.white};
}    
`);

export default StylesOrderManagemnt;
